/**
 * inline_fields_controller.js — click-to-edit a card of plain-text fields (Stimulus).
 *
 * The quote/job/invoice pages get their inline editing from inline-edit and
 * inline-notes, but both are built around the rich editor: they read
 * textarea[name="description_html"] and mount Tiptap/NotesEditor over a
 * `description_html` column. Site has no such column — its description and
 * notes are plain text — so it needs the same *interaction* without the
 * editor. That is all this controller is.
 *
 * Save is deliberately not handled here. The form posts normally, the endpoint
 * answers with a Turbo Stream replacing the whole card, and the replacement
 * renders in display mode with a fresh controller connected to it. Adding a
 * submit handler would only duplicate what Turbo already does correctly.
 *
 * Markup contract inside the root:
 *   .inline-edit-display   the read-only view
 *   .inline-edit-form      the <form>, carrying d-none while closed
 *
 * No editor-coordination protocol: the pages using this have a single editor,
 * and the protocol exists to arbitrate between several. Wire it in when a
 * second one lands on the same page, not before.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.display = this.element.querySelector('.inline-edit-display');
        this.form = this.element.querySelector('.inline-edit-form');
    }

    edit() {
        if (!this.form || !this.display) return;
        this.display.classList.add('d-none');
        this.form.classList.remove('d-none');
        const first = this.form.querySelector('input:not([type="hidden"]), textarea');
        if (first) first.focus();
    }

    cancel() {
        if (!this.form || !this.display) return;
        // reset() restores the values the server rendered, which is what the
        // display block above is still showing.
        this.form.reset();
        this.form.classList.add('d-none');
        this.display.classList.remove('d-none');
    }
}
